import React, { useState, useEffect } from 'react';
import { fetchItSubsystem } from '../../../services/it-subsystem.service';
import PD from '../../../models/pressrelease-downloads.model';

const ITSubsystem: React.FC = () => {
  const [its, setIts] = useState<[PD] | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const loadIT = async () => {
    setLoading(true);
    const data = await fetchItSubsystem();
    setIts(data);
    setLoading(false);
  }

  useEffect(() => {
    loadIT()
  }, [])//eslint-disable-line
  return (
    <>
      {
        loading ? "" :
          <div className="p-2 display-flex info-icon-list" style={{ justifyContent: 'space-evenly', alignItems: 'center', flexWrap: 'wrap' }}>
            {
              its && its.length ?
                its.map((it, i) => {
                  return (
                    <div className=" it-card p-15" key={i}>
                      <div className="text-center">
                        <a href={it.key} target="_blank" rel="noreferrer">
                          <img src={it.value} alt="" style={{ maxWidth: '150px' }} />
                        </a>
                      </div>
                      <a href={it.key} target="_blank" rel="noreferrer">
                        <h3 className="text-16-primary text-center mt-05">
                          {it.name}</h3></a>
                    </div>
                  )
                }) : ""
            }
          </div>
      }
    </>
  )
}

export default ITSubsystem;